(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["iv-cro"] && !Shopify.designMode) return;
  try {
    (() => {
  let consentPromise;
  let cartQueue = Promise.resolve();
  const consentApi = () => {
    if (window.Shopify?.customerPrivacy) return Promise.resolve(window.Shopify.customerPrivacy);
    if (!consentPromise) {
      consentPromise = new Promise((resolve, reject) => {
        if (!window.Shopify?.loadFeatures) return reject(new Error('Consent API unavailable'));
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
          if (error) reject(error);
          else resolve(window.Shopify.customerPrivacy);
        });
      }).catch((error) => {
        consentPromise = undefined;
        throw error;
      });
    }
    return consentPromise;
  };

  document.addEventListener('change', (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.matches('[data-iv-contact]')) return;
    const value = select.value;
    cartQueue = cartQueue.catch(() => {}).then(async () => {
      const status = select.parentElement.querySelector('[data-iv-contact-status]');
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { 'Canal preferencial': value } }),
        });
        if (!response.ok) throw new Error('Cart update failed');
        if (status) status.textContent = select.dataset.saved;
      } catch {
        if (status) status.textContent = select.dataset.error;
      }
    });
  });

  document.addEventListener('click', async (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const dialog = document.getElementById('iv-privacy');
    if (!target || !dialog) return;
    if (target.closest('[data-iv-privacy-close]')) dialog.close();
    if (target.closest('[data-iv-privacy]')) {
      dialog.showModal();
      const status = dialog.querySelector('[data-iv-privacy-status]');
      status.textContent = '';
      try {
        const api = await consentApi();
        const consent = api.currentVisitorConsent();
        dialog.querySelectorAll('input[type="checkbox"]').forEach((input) => {
          input.checked = consent[input.name] === 'yes';
        });
      } catch {
        status.textContent = dialog.dataset.error;
      }
    }
    if (target.closest('[data-iv-privacy-reject]')) {
      dialog.querySelectorAll('input[type="checkbox"]').forEach((input) => { input.checked = false; });
      dialog.querySelector('form').requestSubmit();
    }
  });

  document.addEventListener('submit', async (event) => {
    if (event.target.id !== 'iv-privacy-form') return;
    event.preventDefault();
    const form = event.target;
    const dialog = form.closest('dialog');
    const status = form.querySelector('[data-iv-privacy-status]');
    const consent = Object.fromEntries(Array.from(form.querySelectorAll('input[type="checkbox"]'), (input) => [input.name, input.checked]));
    const buttons = form.querySelectorAll('button');
    buttons.forEach((button) => { button.disabled = true; });
    try {
      const api = await consentApi();
      await new Promise((resolve, reject) => {
        const timeout = setTimeout(() => reject(new Error('Consent timeout')), 10000);
        api.setTrackingConsent(consent, () => { clearTimeout(timeout); resolve(); });
      });
      status.textContent = dialog.dataset.saved;
    } catch {
      status.textContent = dialog.dataset.error;
    } finally {
      buttons.forEach((button) => { button.disabled = false; });
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
